import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import axios from 'axios'
import config from './config'
import ProductComponent from './ProductComponent'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



function JobComponent() {
    const APP_URL = config.apiUrl
    const imageUrl = config.imgUrl;
    const navigate = useNavigate();

    const [productList, setProductList] = useState([]);
    const [products, setProduct] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredProducts, setFilteredProducts] = useState([]);



    useEffect(() => {
        async function fetchJobs() {
            const { data } = await axios.get(
                `${APP_URL}/api/visibleJobs`
            );
            console.log("before state", data)
            setProductList(data);
            console.log("all store properties", productList)
        }

        fetchJobs();

    }, []);

    useEffect(() => {
        async function fetchProducts() {
            const { data } = await axios.get(
                `${APP_URL}/api/products`
            );
            console.log("before state", data)
            setProduct(data);
            console.log("all store properties", products)
        }

        fetchProducts();

    }, []);

    const details = (slug) => {

        navigate(`/jobDetails/${slug}`);
    };
    return (
        <>
            <div className='col-md-6'>
                <div class="tab-class text-center wow fadeInUp" data-wow-delay="0.3s">
                    <ul class="nav nav-pills d-inline-flex justify-content-center border-bottom mb-5">
                        <li class="nav-item">
                            <a class="d-flex align-items-center text-start mx-3 ms-0 pb-3 active" data-bs-toggle="pill" href="#tab-1">
                                <h6 class="mt-n1 mb-0">Jobs</h6>
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div id="tab-1" class="tab-pane fade show p-0 active">

                            {productList.map((product, index) => (
                                <div class="job-item p-4 mb-4" key={index}>
                                    <div class="row g-4">
                                        <div class="col-sm-12 col-md-8 d-flex align-items-center">
                                            <img 
                                                class="flex-shrink-0 img-fluid border rounded" 
                                                src={product.photo1 ? imageUrl + product.photo1 : 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik00MCA0MEM0Ni42MjcgNDAgNTIgMzQuNjI3IDUyIDI4QzUyIDIxLjM3MyA0Ni42MjcgMTYgNDAgMTZDMzMuMzczIDE2IDI4IDIxLjM3MyAyOCAyOEMyOCAzNC42MjcgMzMuMzczIDQwIDQwIDQwWiIgZmlsbD0iIzlDQTNBRiIvPgo8cGF0aCBkPSJNNDAgNDhDNDYuNjI3IDQ4IDUyIDQyLjYyNyA1MiAzNkM1MiAyOS4zNzMgNDYuNjI3IDI0IDQwIDI0QzMzLjM3MyAyNCAyOCAyOS4zNzMgMjggMzZDMjggNDIuNjI3IDMzLjM3MyA0OCA0MCA0OFoiIGZpbGw9IiM5Q0EzQUYiLz4KPC9zdmc+'} 
                                                alt={product.title || 'Job image'} 
                                                style={{ width: "80px", height: "80px" }}
                                                onError={(e) => {
                                                    console.error('Image failed to load:', e.target.src);
                                                    e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik00MCA0MEM0Ni42MjcgNDAgNTIgMzQuNjI3IDUyIDI4QzUyIDIxLjM3MyA0Ni42MjcgMTYgNDAgMTZDMzMuMzczIDE2IDI4IDIxLjM3MyAyOCAyOEMyOCAzNC42MjcgMzMuMzczIDQwIDQwIDQwWiIgZmlsbD0iIzlDQTNBRiIvPgo8cGF0aCBkPSJNNDAgNDhDNDYuNjI3IDQ4IDUyIDQyLjYyNyA1MiAzNkM1MiAyOS4zNzMgNDYuNjI3IDI0IDQwIDI0QzMzLjM3MyAyNCAyOCAyOS4zNzMgMjggMzZDMjggNDIuNjI3IDMzLjM3MyA0OCA0MCA0OFoiIGZpbGw9IiM5Q0EzQUYiLz4KPC9zdmc+';
                                                }}
                                            />
                                            <div class="text-start ps-4">
                                                <h5 class="mb-3">{product.title}</h5>
                                                <span class="text-truncate me-3"><i class="fa fa-map-marker-alt text-primary me-2"></i>{product.location}</span>
                                                <span class="text-truncate me-3"><i class="fa fa-eye text-primary me-2"></i>{product.views_count}</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-4 d-flex flex-column align-items-start align-items-md-end justify-content-center">
                                            <div class="d-flex mb-3">
                                                <a class="btn btn-light btn-square me-3" href=""><i class="far fa-heart text-primary"></i></a>
                                                <button class="btn btn-primary" onClick={() => details(product.slug)}>View Details</button>
                                            </div>
                                            <small class="text-truncate"><i class="far fa-calendar-alt text-primary me-2"></i>Posted On:{product.posted_date}</small>
                                            <small class="text-truncate"><i class="far fa-calendar-alt text-primary me-2"></i>Deadline: {product.deadline}</small>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default JobComponent